export const KEYPAIR_STORAGE_KEY = "@@my-game-storage/local-privkey";

export const SUBNET_ID = process.env.REACT_APP_SUBNET_ID ?? "";
export const TOPIC_ID = process.env.REACT_APP_TOPIC_ID ?? "";
export const VALIDATOR_PUBLIC_KEY = process.env.REACT_APP_VALIDATOR ?? '';
export const ML_CHAIN_ID = `${
  process.env.REACT_APP_MLAYER_CHAIN_ID ?? "31337"
}`;
export const NODE_HTTP = process.env.REACT_APP_NODE_HTTP ?? "";
